import { Container, Label, TooltipDiv } from '../common/Tooltip.styles';

export interface TooltipProps {
    text: string;
    children: React.ReactNode;
}

const Tooltip = (props: TooltipProps) => {
    const { text, children } = props;
    return (
        <Container>
            {children}
            {text && (
                <TooltipDiv>
                    <Label> {text} </Label>
                </TooltipDiv>
            )}
        </Container>
    );
};

export default Tooltip;
